import { CompositeLayer } from '@deck.gl/core'
import { ScatterplotLayer, IconLayer } from '@deck.gl/layers'

class PointRadiusLayer extends CompositeLayer {
  renderLayers () {
    return [
      new ScatterplotLayer(
        this.getSubLayerProps({
          id: 'radius-circle',
          radiusUnits: this.props.radiusUnits,
          data: this.props.data,
          visible: this.props.visible,
          filled: this.props.circleFilled,
          stroked: this.props.circleStroked,
          getFillColor: this.props.getFillColor,
          getLineColor: this.props.getLineColor,
          getRadius: this.props.getRadius,
          lineWidthMinPixels: this.props.circleLineWidthMinPixels,
          getPosition: this.props.getPosition,
          updateTriggers: this.props.updateTriggers
        })
      ),
      new IconLayer(
        this.getSubLayerProps({
          id: 'point-icon',
          data: this.props.data,
          visible: this.props.visible,
          getPosition: this.props.getPosition,
          getIcon: this.props.getIcon,
          getSize: this.props.getIconSize,
          sizeScale: this.props.iconSizeScale,
          updateTriggers: this.props.updateTriggers
        })
      )
    ]
  }
}

PointRadiusLayer.layerName = 'PointRadiusLayer'
PointRadiusLayer.defaultProps = {
  radiusUnits: 'meters',
  circleStroked: true,
  circleFilled: true,
  circleLineWidthMinPixels: 2,
  getFillColor: { type: 'accesor', value: [22, 150, 157, 51] },
  getLineColor: { type: 'accesor', value: [22, 150, 157] },
  getRadius: { type: 'accesor', value: 500 },
  getIconSize: { type: 'accesor', value: 1 },
  iconSizeScale: 48
}

export default PointRadiusLayer
